export default {
  rateExceeded: 'Request limit exceeded. App will resume in {ttl} seconds.',
};
